var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2857 3.34934C14.75 3.61921 14.2143 3.70917 13.5893 3.79913C14.2143 3.4393 14.6607 2.89956 14.8393 2.17991C14.3036 2.53974 13.6786 2.71965 12.9643 2.89956C12.4286 2.35983 11.625 2 10.8214 2C9.30357 2 7.96429 3.34935 7.96429 4.96856C7.96429 5.23843 7.96429 5.41834 8.05357 5.59825C5.64286 5.5083 3.41071 4.33886 1.98214 2.53974C1.71429 2.98952 1.625 3.4393 1.625 4.069C1.625 5.05852 2.16071 5.95808 2.96429 6.49782C2.51786 6.49782 2.07143 6.3179 1.625 6.13799C1.625 7.57729 2.60714 8.74673 3.94643 9.01659C3.67857 9.10655 3.41071 9.10655 3.14286 9.10655C2.96429 9.10655 2.78571 9.10655 2.60714 9.01659C2.96429 10.186 4.03571 11.0856 5.375 11.0856C4.39286 11.8952 3.14286 12.345 1.71429 12.345C1.44643 12.345 1.26786 12.345 1 12.345C2.33929 13.1546 3.85714 13.6943 5.46429 13.6943C10.8214 13.6943 13.7679 9.19651 13.7679 5.32838C13.7679 5.23843 13.7679 5.05852 13.7679 4.96856C14.3929 4.51878 14.9286 3.97904 15.2857 3.34934Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c7fda1b480029a1063919d8068a87d54.svg";
export { ForwardRef as ReactComponent };